import React from 'react';
import { axiosAuth } from './apiBase';

import { handleResponse, handleError } from './response';
const useGLSalarySlabItemsService = () => {
    const getGLSalarySlabItems = async () => {
        try {
            const response = await axiosAuth.get(`/api/GLSalarySlabItems`);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };
    const addGLSalarySlabItems = async (values) => {
        try {
            const response = await axiosAuth.post(`/api/GLSalarySlabItems`, values);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };

    const updateGLSalarySlabItems = async (id, values) => {
        try {
            const response = await axiosAuth.put(`/api/GLSalarySlabItems?Id=${id}`, values);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };

    const softDeleteGLSalarySlabItems = async (id) => {
        try {
            const response = await axiosAuth.delete(`/api/GLSalarySlabItems/soft-delete?Id=${id}`);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };
    return { getGLSalarySlabItems, addGLSalarySlabItems, updateGLSalarySlabItems, softDeleteGLSalarySlabItems };
};

export default useGLSalarySlabItemsService;
